import { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from '../config.js';

const IDLE_TIME = 30 * 60 * 1000; // ✅ 1 minute

const useIdleLogout = () => {
  useEffect(() => {
    let idleTimer;

    const logout = async () => {
      try {
        await axios.post(API_BASE_URL +"logout", {}, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        });
      } catch (error) {
        console.error("Logout API failed", error);
      } finally {
        localStorage.clear();
        window.location.href = "";
      }
    };

    const resetTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(logout, IDLE_TIME);
    };

    ["mousemove", "keydown", "click", "scroll"].forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer();

    return () => {
      clearTimeout(idleTimer);
      ["mousemove", "keydown", "click", "scroll"].forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, []);
};

export default useIdleLogout;
